import React from "react";
import image2 from "../utils/images/seoimages/OurServices.png";
import "./Besok.css";

import "./Besok.css";

const Besok = () => {
  return (
    <div className="imageContainerVisit">
      <div className="sectionItems">
        <h2 className="imageContainerVisitTitle"> Digitala lösningar och tjänster</h2>
        <img
          src={image2}
          className="imageContainerVisitimg"
          loading="lazy"
          alt="Våra Tjänster - En översikt av digitala tjänster, inklusive webbdesign, e-handel, innehållsskapande, SEO-tjänster, digital marknadsföring, PPC-annonsering, och UX-design."
        />
      </div>
    </div>
  );
};

export default Besok;
